import { USER_ADMIN } from 'constants/controllers'
import { Controller } from 'libraries/front-end-core/core/Router'
import getUrl from 'libraries/front-end-core/core/url'
import Main from './Main'

export default new Controller({
  name: USER_ADMIN,
  route: '(:aol/)useradmin(/:view)',
  controller (
    Router,
    { params: { view, aol } },
    render
  ) {
    const pageId = getUrl(USER_ADMIN, { view, aol })
    render(
      { Main },
      { view, aol },
      { pageId, aol, className: 'user-admin' }
    )
    return pageId
  }
})
